/** EN uses Swedish values until translated. */
export const pagesConvertiblesEn = {
    sections: {
        about: 'About the convertible loan',
        events: 'Activity',
        other: 'Other',
    },
    status: {
        label: 'Status',
        repaid: 'Repaid loan',
        unusedCreditLine: 'Undrawn credit facility',
        outstandingLoan: 'Outstanding loan',
    },
    creditLine: 'Credit facility',
    loanAmount: 'Loan amount',
    maturityDate: 'Due date',
    convertAnytime: 'Conversion may take place at any time until due date',
    noncashConsideration: 'Non-cash consideration',
    interest: {
        arrangementFee: 'Set-up fee',
        monthly: 'Monthly interest',
        annual: 'Annual interest',
        label: 'Interest',
        interestFree: 'Interest free',
        stiborPlus: 'STIBOR +',
    },
    conversionPrice: {
        label: 'Conversion price',
    },
    advisors: {
        financial: 'Financial advisor',
        legal: 'Legal advisor',
    },
    events: {
        activity: 'Activity',
        conversionPrice: 'Conversion price',
        empty: 'No activity registered for this convertible',
    },
    investors: {
        share: 'Ratio',
        unnamed: 'Unnamed',
        incompleteInfo: 'Complete information regarding investors and the amounts involved has not been communicated by the company.',
    },
    lendersReceivedWarrants: 'Lender received warrants',
}
